import { Injectable } from '@angular/core';
import {Platform} from "@ionic/angular/lazy";
import {StorageService} from "./storage.service";
import {ToastService} from "./toast.service";
import {ContentService} from "./content.service";
import {LangService} from "./lang.service";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class MssInitService {
    constructor(
        private platform: Platform,
        private storageService: StorageService,
        private toastService: ToastService,
        private contentService: ContentService,
        private lang: LangService
    ) {}
    init() {
        return new Promise<void>(async (resolve, reject) => {
            await this.toastService.showLoading();
            await this.storageService.init();
            await this.platform.ready();
            await this.lang.init(environment.defaultLanguage)
            await this.contentService.init();
            //Set General theme data
            document.body.setAttribute('data-theme', 'light');
            document.body.classList.toggle('dark', false);

            //Dismiss and proceed to the app
            await this.toastService.dismissLoading();
            resolve();
        });
    }
}
